module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/357.8e2a35fd.png";